import Toast, { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { Message } from "@/models/messages/interfaces";
import { TOAST_COMPONENT_OPTIONS } from "@/utils/";
import { ToastID, ToastOptions, PluginOptions } from "vue-toastification/dist/types/types";
import AppMessageNotifier from "@/components/base/app-message-notifier/AppMessageNotifier.vue";
import router from "../routes";
import app from "../main";

export const ToastPlugin = Toast;
export const toastPluginOptions: PluginOptions = {
  onMounted: (_, toastApp) => {
    // Register the router. "shareAppContext: true" should do this job, but it's not working.
    // This router registration allows us to use router-link component inside the toaster.
    toastApp.use(router);
  },
  shareAppContext: true
};

export const showToastNotification = (message: Message): ToastID | undefined => {
  const toast = useToast();
  if (!message || !message.id) return;

  const toastOptions = {
    ...TOAST_COMPONENT_OPTIONS,
    ...message.toastOptions
  } as ToastOptions;

  return toast(
    {
      component: app.component(message.componentName || AppMessageNotifier.name),
      props: { messageId: message.id, messageType: message.type }
    },
    toastOptions
  );
};

export const suscribeToastToMessages = () => {
  const store = useStore();

  store.subscribe((mutation) => {
    if (mutation.type === "messages/addMessageItem") {
      const messages: { [key: number]: Message } = store.getters["messages/messageList"];

      for (const messageId in messages) {
        // removes the Proxy overhead
        const message = Object.assign({}, messages[messageId]);

        showToastNotification(message);
      }
    }
  });
};
